import React from 'react'
import InputBox from 'containers/common/components/InputBox'
import Select from '../../../commons/Select'

const frequencyOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'weekly', label: 'Weekly' },
]

class RentWorth extends React.Component {

  render() {
    const {
      errorMessage,
      value,
      onChange,
      frequencyValue,
      onFrequencyChange,
      disabled,
    } = this.props

    return(
      <div>
        <div className='mb-3' />
        <div className='grey smaller mb-2'>
          How much rent do you think you can get for your current home?
        </div>
        <div className='form-group'>
          <InputBox
            id={ 'currentHomeRentWorth' }
            disabled={ disabled }
            errorMessage={ errorMessage }
            onChange={ (e) => { onChange(e.currentTarget.value) } }
            value={ value }
            displayMonthly={ false }
          >
            <Select
              readOnly={ disabled }
              defaultValue={ frequencyValue || frequencyOptions[0].value }
              onChange={ (value) => onFrequencyChange(value) }
              options={frequencyOptions}
            />
          </InputBox>
        </div>
      </div>
    )
  }
}

export default RentWorth
